import React from "react";
import "./style.css";

const Button = ({ value, className, srOnly, selected, onClick, disabled, children }) => {
  return (
    <button className={className} onClick={onClick} disabled={disabled ?? false}>
      <span>{value}</span>
      {selected && <span>{selected}</span>}
      {children}
      <p className="sr-only"> {srOnly}</p>
    </button>
  );
};

export default Button;
